import React from 'react';
import ModelFormItem from "./model-form-item";


const AddNewCaseStudySlider = () => {


    return(
        
        <div className="modal fade register-model" id="addnewcasestudySliderModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="close-model" data-dismiss="modal">X</div>
                        <div className="title-content">
                            <h3 className="model-title">إضافة سلايدر جديد</h3>
                        </div>
                        <form>
                       
                        
                            <ModelFormItem inputName={"اسم الشركة"} inputType={"text"} />

                            <div className="form-group cassandra-form-group">
                                <label>وصف الشركة  </label>
                                <textarea className="form-control cassandra-form-control" rows="4"  placeholder="وصف مختصر للشركة ..."/>
                            </div>

                            <ModelFormItem inputName={"لوجو الشركة"} inputType={"file"}/>
                        
                    
                            <div className="text-center">
                            <input className="submit-btn" type="submit" value="حفظ"/>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
         </div>
    );

};
export default AddNewCaseStudySlider;
